import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { groupSupplierDocuments } from 'features/supplier/utils';

import AddSupportingDocuments from '@features/supplier/component/AddSupportingDocuments';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { useSupplierDocuments } from '@store/reducers/supplier-onboarding/OnboardingReducer';

import { fetchEnumValues } from '@services/commonService';
import { getSupplierDocuments } from '@services/supplierOnboardingService';

import { getFileType, getIconByFileType, printApiError, replaceSymbols } from '@utils/Util';

const AdditionalDocuments = ({ isAdd, onSetAdd }) => {
	const documents = useSupplierDocuments();
	const [documentTypes, setDocumentTypes] = useState([]);
	const { id } = useParams();
	const dispatch = useDispatch();

	const fetchDocumentTypes = async () => {
		try {
			dispatch(openLoader());
			const data = await fetchEnumValues('info.nitex.app.supplier.SupportingDocumentType');
			setDocumentTypes(data?.map((item) => ({ id: item.constant, value: item.name })));
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	useEffect(() => {
		(async () => {
			await Promise.all([fetchDocumentTypes()]);
		})();
	}, [id]);

	const renderDocuments = () => {
		if (documents?.supportingDocumentList?.length > 0) {
			const groupedDocuments = groupSupplierDocuments(
				documents.supportingDocumentList,
				'supportingDocumentType'
			);

			return Object.keys(groupedDocuments)?.map((item) => {
				return (
					<div className="info-single" key={`supporting_doc_${item}`}>
						<p className="gray_dark_01 regular-14 weight-600">{replaceSymbols(item, '_', ' ')}</p>
						{groupedDocuments[item]?.map((doc) => {
							let fileType;
							if (doc.documentResponse.docUrl) {
								fileType = getFileType(doc.documentResponse.docUrl);
							} else {
								fileType = getFileType(doc.documentResponse.name);
							}
							return (
								<div
									key={`doc_${doc.id}`}
									className="addition-info d-flex align-items-center cursor-pointer pt-1"
									onClick={() => window.open(doc.documentResponse.docUrl, '_blank')}
								>
									<img src={getIconByFileType(fileType)} alt="" width={19} />
									<p className="regular-12 pl-1">{doc.documentResponse.name}</p>
								</div>
							);
						})}
					</div>
				);
			});
		}
	};

	return (
		<>
			<div className="row">
				<div className="additional-information w-100">
					<div className="additional-info-items">{renderDocuments()}</div>
				</div>
			</div>
			{isAdd && (
				<AddSupportingDocuments
					onClose={() => onSetAdd(false)}
					documentResponseList={documents?.supportingDocumentList || []}
					documentTypes={documentTypes}
					callBack={() => dispatch(getSupplierDocuments(id))}
				/>
			)}
		</>
	);
};

export default AdditionalDocuments;
